import { Link, useNavigate } from "react-router-dom";

import { Bus, Flight, Hotel, Train } from "../../../assets/jpg";

import { TRAVEL_BUS_MODULE, TRAVEL_FLIGHT_MODULE, TRAVEL_HOTEL_MODULE, TRAVEL_TRAIN_MODULE } from "../../../Routes/RoutesContant";

import Button from "../../CommonComponents/Button";

import { HighlightedText } from "../../../Utils/CommonFunctions";

const TravelStyle = "min-w-[150px] md:min-w-[310px] max-w-[310px] w-auto md:w-full h-[150px] md:h-[240px] rounded-[10px] md:rounded-[20px]";
const TravelImageStyle = "object-fill w-full h-full rounded-[10px] md:rounded-[20px]";

const TravelComponents = {
  flight: ({ link, logo }) => (
    <Link to={link} className={TravelStyle}>
      <img
        src={logo}
        alt="Flight"
        loading="lazy"
        className={TravelImageStyle}
      />
    </Link>
  ),
  hotel: ({ link, logo }) => (
    <Link to={link} className={TravelStyle}>
      <img
        src={logo}
        alt="Hotel"
        loading="lazy"
        className={TravelImageStyle}
      />
    </Link>
  ),
  bus: ({ link, logo }) => (
    <Link to={link} className={TravelStyle}>
      <img
        src={logo}
        alt="Bus"
        loading="lazy"
        className={TravelImageStyle}
      />
    </Link>
  ),
  train: ({ link, logo }) => (
    <Link to={link} className={TravelStyle}>
      <img
        src={logo}
        alt="Train"
        loading="lazy"
        className={TravelImageStyle}
      />
    </Link>
  )
};

export default function TravelSection({ integratorTheme, subModuleArray, websiteLandingPageInfo }) {
  const navigate = useNavigate();

  const getTravelData = (type) => {
    const travelMap = {
      flight: {
        link: TRAVEL_FLIGHT_MODULE,
        logo: Flight
      },
      hotel: {
        link: TRAVEL_HOTEL_MODULE,
        logo: Hotel
      },
      bus: {
        link: TRAVEL_BUS_MODULE,
        logo: Bus
      },
      train: {
        link: TRAVEL_TRAIN_MODULE,
        logo: Train
      }
    };
    return travelMap[type] || null;
  };

  return (
    <div className="container flex py-5 md:pb-11 md:mt-0 flex-col pl-5 -pr-5 md:px-5 mx-auto relative">
      <div className="flex gap-2.5 items-start md:items-center justify-between">
        <div className="flex gap-2.5 items-center">
          <div className="flex flex-col gap-0 md:gap-1">
            {websiteLandingPageInfo?.is_travel_title_present && (<div className="font-Inter text-2xl md:text-4xl font-semibold cursor-pointer"
              onClick={() => navigate(TRAVEL_FLIGHT_MODULE)}>
              <HighlightedText
                text={websiteLandingPageInfo?.travel_title}
                integratorTheme={integratorTheme}
              />
            </div>)}
            {websiteLandingPageInfo?.is_travel_subtitle_present && (<div className="font-Inter ">
              <HighlightedText
                text={websiteLandingPageInfo?.is_travel_subtitle_present && websiteLandingPageInfo?.travel_subtitle}
                integratorTheme={integratorTheme}
              />
            </div>)}
          </div>
        </div>
        <Button
          variant="primary"
          size="sm"
          theme={integratorTheme}
          className="md:px-5 text-base hidden md:block mr-2 md:mr-0 font-medium h-auto p-2.5 md:py-0 w-[150px] md:w-auto md:h-10"
          onClick={() => navigate(TRAVEL_FLIGHT_MODULE)}
        >
          View All
        </Button>
      </div>
      {/* <div className="flex justify-end">
        <Button
          variant="primary"
          size="sm"
          theme={integratorTheme}
          className="md:px-5 block md:hidden mr-2 md:mr-0 text-base font-medium h-auto p-2.5 md:py-0 w-fit md:w-auto md:h-10 mt-2"
          onClick={() => navigate(TRAVEL_FLIGHT_MODULE)}
        >
          View All
        </Button>
      </div> */}

      <div className="flex gap-4 md:gap-8 mt-5 overflow-x-scroll travelScroll">
        {subModuleArray.map((subModule) => {
          const Component = TravelComponents[subModule];
          const travelData = getTravelData(subModule);

          if (!Component || !travelData) return null;

          return (
            <Component
              key={subModule}
              {...travelData}
            />
          );
        })}
      </div>
    </div>
  );
};